import { NeighbouringImage, type NeighbouringImageProps } from './NeighbouringImage';

type NeighbouringImageSetProps = {
  images: NeighbouringImageProps[] | undefined;
};

export const NeighbouringImageSet = ({ images }: NeighbouringImageSetProps) => {
  return (
    <>
      {images?.map((image) => (
        <NeighbouringImage {...image} key={image.key} />
      ))}
    </>
  );
};
